import React from 'react';
import useProjectDefinition from 'src/app/projects/views/new-project-definition/hooks/useProjectDefinition';
import ErrorMessage from 'src/shared/components/error-msg/ErrorMessage';
import SuccessMessage from 'src/shared/components/success-message/SuccessMessage';
import HabitatInsightsSamplesUpload from './components/habitat-insights-samples-upload/HabitatInsightsSamplesUpload';

export const HabitatInsightsSamples = () => {
    const { formState } = useProjectDefinition();

    const { habitatInsightsUploadedFileErrors, habitatInsightsUploadedFileContent } = formState;

    return (
        <div className='w-[720px] flex flex-col'>
            <HabitatInsightsSamplesUpload />
            <div className='mt-[50px]'>
                {habitatInsightsUploadedFileContent.length > 0 ? (
                    habitatInsightsUploadedFileErrors.length > 0 ? (
                        <ul>
                            {habitatInsightsUploadedFileErrors.map((error, index) => (
                                <ErrorMessage key={index} message={<span dangerouslySetInnerHTML={{ __html: error.message }} />} />
                            ))}
                        </ul>
                    ) : (
                        <SuccessMessage message={'Data successfully loaded with no errors'} />
                    )
                ) : null}
            </div>
        </div>
    );
};

export default HabitatInsightsSamples;
